import type { SyncHasMany } from "@ember-data/model";
import Model, { attr, hasMany } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";

export default class AdverseEventModel extends Model {
  @attr() type?: "discrete";
  @attr() values?: number[];

  @hasMany("therapeutical-area", { async: false, inverse: "adverseEvents" })
  declare therapeuticalAreas: SyncHasMany<ModelRegistry["therapeutical-area"]>;
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "adverse-event": AdverseEventModel;
  }
}
